module.exports = __webpack_public_path__ + "img/ValidationReport_1.6277f1db.jpg";